import { Injectable } from "@angular/core";
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseApi } from "../laas/base-api.service";
import { environment as ENV } from "../../environments/environment";
import { JwtHelperService } from "@auth0/angular-jwt";
import { ApplicantService } from "app/laas/applicant.service";
import { UntypedFormControl } from "@angular/forms";
import { map } from "rxjs/operators";

@Injectable()
export class FreshAuthService {
  searchEndpoint: string = `/v1/applicants/userSearch`;
  search = new UntypedFormControl();
  adminId: string;
  maxDate: any;
  getMonth: any;
  getYear: number;

  constructor(private api: BaseApi) {
    this.adminId = sessionStorage.getItem('wl-admin-id');
  }

  loanDisbursed(
    adminId,
    branch_code,
    ro_code,
    zonal_code,
    offset = 0,
    limit = 10,
    roleId = 1,
    filter = '',
    data_type = 'loan_disbursed'
  ) {
    let filterDate = sessionStorage.getItem('filterDateDisbursed')
      ? sessionStorage.getItem('filterDateDisbursed')
      : '';
    let data = {
      adminId,
      branch_code,
      ro_code,
      zonal_code,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      data['filter_date'] = dateInMs;
    }

    return this.api.userSearchIsResultTrue(
      `${this.searchEndpoint}`,
      data

      // {
      //     "adminId": "aa50fd50-768d-482d-88a6-5de6e348330d",
      //     "roleId": 1,
      //     "filter": "",
      //     "offset": 0,
      //     "limit": 10,
      //     "data_type": "loan_disbursed",
      //     "branch_code": "02172",
      //     "ro_code": "49580",
      //     "zonal_code": "64960"
      // }
    );
  }

  getUsers(input, roleId, offset, limit, type) {
    let filterDate = sessionStorage.getItem('filterDateDisbursed')
      ? sessionStorage.getItem('filterDateDisbursed')
      : '';
    let dataObj = {
      adminId: this.adminId,
      roleId: sessionStorage.getItem('getroleId'),
      // "roleId": 1,
      filter: input,
      offset: offset,
      limit: limit,
      data_type: type,
      date_type: 'dateRange',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
      // Shared by every listing screen, but only the review inbox reads it back
      // — it is what keeps the maker/checker Action column correct when paging.
      approvalStage: sessionStorage.getItem('approvalStage') || '',
    };
    // if (filterDate) {
    //   let date = new Date(filterDate);
    //   let dateInMs = date.getTime();
    //   dataObj["filter_date"] = dateInMs;
    // }
    if (
      sessionStorage.getItem('filterDateDisbursedStart') &&
      sessionStorage.getItem('filterDateDisbursedEnd')
    ) {
      console.log('inside service disburshed');
      dataObj['filter_date'] = parseInt(sessionStorage.getItem('filterDateDisbursedStart'));
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateDisbursedEnd'));
    }
    if (
      sessionStorage.getItem('filterDateIncompleteStart') &&
      sessionStorage.getItem('filterDateIncompleteEnd')
    ) {
      console.log('inside service incomplete');
      dataObj['filter_date'] = parseInt(sessionStorage.getItem('filterDateIncompleteStart'));
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateIncompleteEnd'));
    }
    if (
      sessionStorage.getItem('filterDateFailureStart') &&
      sessionStorage.getItem('filterDateFailureEnd')
    ) {
      console.log('inside service failure');
      dataObj['filter_date'] = parseInt(sessionStorage.getItem('filterDateFailureStart'));
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateFailureEnd'));
    }
    if (
      sessionStorage.getItem('filterDateReviewInboxStart') &&
      sessionStorage.getItem('filterDateReviewInboxEnd')
    ) {
      console.log('inside service review inbox');
      dataObj['filter_date'] = parseInt(sessionStorage.getItem('filterDateReviewInboxStart'));
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateReviewInboxEnd'));
    }

    return this.api.userSearchIsResultTrue('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));

    // return this.api.newPost(`/users/search-users/${page}`, { input: input ? input : '' }, true).map(res => {
    //   if (!res.result) {
    //     return '';
    //   }
    //   let i = page * 10 - 9;
    //   res.result.forEach(user => user.srNo = i++)
    //   return res;
    // })
  }

  getErrorUsers(input, roleId, offset, limit, startDateConvert, endDateConvert, level) {
    // let filterDate = sessionStorage.getItem("filterDateDisbursed")
    //   ? sessionStorage.getItem("filterDateDisbursed")
    //   : "";
    let adminId = sessionStorage.getItem('wl-admin-id');
    // let adminId = '053987bc-a89c-4dbe-a73e-ec4a8edf87ca';
    let storeDate = {
      from: startDateConvert,
      to: endDateConvert,
    };
    let dataObj = {
      date: storeDate,
      userId: adminId,
      roleId: sessionStorage.getItem('getroleId'),
      // "roleId": 1,
      searchQuery: input,
      currentPage: offset,
      recordsPerPage: limit,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
      level,
    };
    // if (filterDate) {
    //   let date = new Date(filterDate);
    //   let dateInMs = date.getTime();
    //   dataObj["filter_date"] = dateInMs;
    // }
    if (
      sessionStorage.getItem('filterDateDisbursedStart') &&
      sessionStorage.getItem('filterDateDisbursedEnd')
    ) {
      console.log('inside service disburshed');
      dataObj['filter_date'] = parseInt(sessionStorage.getItem('filterDateDisbursedStart'));
      dataObj['end_date'] = parseInt(sessionStorage.getItem('filterDateDisbursedEnd'));
    }

    return this.api.userSearch1('/v1/blg/getErrorLogs', dataObj).pipe(map((resp) => {
      console.log('response', resp);
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.results) {
        return resp;
      }
    }));
  }

  loanSanctioned(
    adminId,
    branch_code,
    ro_code,
    zonal_code,
    offset,
    limit,
    roleId = 1,
    filter,
    data_type: 'loan_sanctioned_ntb'
  ) {
    let data = {
      adminId,
      branch_code,
      ro_code,
      zonal_code,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
      date_type: 'dateRange',
    };
    if (
      sessionStorage.getItem('filterDateSanctionStart') &&
      sessionStorage.getItem('filterDateSanctionEnd')
    ) {
      console.log('inside service');
      data['filter_date'] = parseInt(sessionStorage.getItem('filterDateSanctionStart'));
      data['end_date'] = parseInt(sessionStorage.getItem('filterDateSanctionEnd'));
    }

    return this.api.userSearch(`${this.searchEndpoint}`, data);
  }

  loanSanctionedEtb(
    adminId,
    branch_code,
    ro_code,
    zonal_code,
    offset,
    limit,
    roleId = 1,
    filter,
    data_type: 'loan_sanctioned_etb'
  ) {
    let data = {
      adminId,
      branch_code,
      ro_code,
      zonal_code,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
      date_type: 'dateRange',
    };
    if (sessionStorage.getItem('filterDateEtbStart') && sessionStorage.getItem('filterDateEtbEnd')) {
      console.log('inside service');
      data['filter_date'] = parseInt(sessionStorage.getItem('filterDateEtbStart'));
      data['end_date'] = parseInt(sessionStorage.getItem('filterDateEtbEnd'));
    }

    return this.api.userSearch(`${this.searchEndpoint}`, data);
  }

  updateCustId(value, id) {
    return this.api
      .postWebhook('/webhook/updatecustId', { custId: value, appId: id })
      .pipe(map((res) => {
        return res;
      }));
  }

  fetchUsersChecklistOptions(){
    return this.api.getComplt('/blg/fetchUsersChecklistOptions')
  }

  submitCheckboxes(data){
    return this.api.postResMp('/blg/saveUsersChecklistOptions',data)
  }

  generateReferenceID(id, type) {
    return this.api
      .postWebhook(`/v1/nesl/convertimage_new`, { appId: id, docType: type })
      .pipe(map((resp) => {
        console.log('create account resp' + JSON.stringify(resp));
        return resp;
      }));
  }

  loan_incomplete_jrny(
    adminId,
    roleId = 1,
    filter = '',
    offset = 50,
    limit = 10,
    data_type: 'loan_incomplete_jrny',
    branch_code,
    ro_code,
    zonal_code
  ) {
    return this.api.userSearch(`${this.searchEndpoint}`, {
      adminId,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
      branch_code,
      ro_code,
      zonal_code,
    });
  }

   loan_Review_Inbox_jrny(
    adminId,
    roleId = 1,
    filter = '',
    offset = 50,
    limit = 10,
    data_type: 'review',
    branch_code,
    ro_code,
    zonal_code
  ) {
    // isResult must be TRUE here: with the default (false) BaseApiService.
    // userSearch returns res['result'] and throws the envelope away — and
    // approvalStage sits on the envelope, NEXT TO result, not inside it. The
    // component would never see it. So take the whole response and flatten it
    // back to result's own shape (resultData / count, which is what callers
    // read) with approvalStage carried across.
    return this.api.userSearch(`${this.searchEndpoint}`, {
      adminId,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
      branch_code,
      ro_code,
      zonal_code,
      approvalStage: sessionStorage.getItem('approvalStage') || '',
    }, true).pipe(map((res) => ({
      ...(res && res.result ? res.result : {}),
      approvalStage: res && res.approvalStage,
    })));
  }

  loan_failure_page(
    adminId,
    roleId = 1,
    filter = '',
    offset = 50,
    limit = 10,
    data_type: 'loan_failure_page',
    branch_code,
    ro_code,
    zonal_code
  ) {
    return this.api.userSearch(`${this.searchEndpoint}`, {
      adminId,
      roleId: this.getRoleId(),
      filter,
      offset,
      limit,
      data_type,
      branch_code,
      ro_code,
      zonal_code,
    });
  }
  get_error_log(offset, limit, searchQuery, startDateConvert, endDateConvert, level) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    //  let adminId = '053987bc-a89c-4dbe-a73e-ec4a8edf87ca';

    let storeDate = {
      from: startDateConvert,
      to: endDateConvert,
    };
    let dataObj = {
      date: storeDate,
      userId: adminId,
      roleId: 0,
      // date_type: dateType,
      searchQuery: searchQuery,
      level: level,
      currentPage: offset,
      recordsPerPage: limit,
      // branch_code: sessionStorage.getItem("branch_code"),
      // ro_code: sessionStorage.getItem("ro_code"),
      // zonal_code: sessionStorage.getItem("zonal_code"),
    };

    return this.api.postResUserSearch('/v1/blg/getErrorLogs', dataObj).pipe(map((resp) => {
      if (resp && resp.results) {
        return resp;
      }
    }));
  }

  downloadErrorFile(searchQuery, startDate, endDate, level) {
    let dataObj = {
      searchQuery,
      date: {
        from: startDate,
        to: endDate,
      },
      level,
      roleId: 0,
      // "userId": "053987bc-a89c-4dbe-a73e-ec4a8edf87ca"
      "userId": sessionStorage.getItem("wl-admin-id")
    }
    return this.api
    .postResUserSearch("/v1/mis/error-logs", dataObj)
    .pipe(map((resp) => {
      return resp;
    }));
  }

  getErrorLogFilter(searchQuery, roleId, offset, limit, level, startDate, endDate) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    // let adminId = '053987bc-a89c-4dbe-a73e-ec4a8edf87ca';
    // let filterDate = sessionStorage.getItem("filterDateDashboard")
    //   ? sessionStorage.getItem("filterDateDashboard")
    //   : "";
    let storeDate = {
      from: startDate,
      to: endDate,
    };
    let dataObj = {
      date: storeDate,
      userId: adminId,
      roleId: 0,
      level,
      currentPage: offset,
      recordsPerPage: limit,
      searchQuery,
    };
    // if (filterDate) {
    //   let date = new Date(filterDate);
    //   let dateInMs = date.getTime();
    //   dataObj["filter_date"] = dateInMs;
    // }

    return this.api.postResUserSearch('/v1/blg/getErrorLogs', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.results) {
        return resp;
      }
    }));
  }

  getLoanFailureUsers(input, roleId, offset, limit) {
    // muruga
    let adminId = sessionStorage.getItem('wl-admin-id');
    let filterDate = sessionStorage.getItem('filterDateDashboard')
      ? sessionStorage.getItem('filterDateDashboard')
      : '';
    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_failure_page',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if(state =="MADHYAPRADESH" || state == "MP"){
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   console.log('-----------else-----------');
    //   return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if(resp && resp.result && resp.result.resultData){
    //       return resp;
    //     }

    //   })
    // }
  }
  getErrorLogFilterDate(
    input,
    roleId,
    offset,
    limit,
    filterDate,
    endDateInMs,
    dateType,
    dropdownSelection
  ) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      userId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'error-log',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      dropdownSelection: dropdownSelection,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate1 = sessionStorage.getItem('filterDateFailure')
      ? sessionStorage.getItem('filterDateFailure')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    //  if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/blg/getErrorLogs', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

  getFailureUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {
    // muruga
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_failure_page',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate1 = sessionStorage.getItem('filterDateFailure')
      ? sessionStorage.getItem('filterDateFailure')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    //  if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

   getReviewInboxUsers(input, roleId, offset, limit) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    let filterDate = sessionStorage.getItem('filterDateDashboard')
      ? sessionStorage.getItem('filterDateDashboard')
      : '';
    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'review',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
      // 'maker' | 'checker', stored at login by AdminAuthService.storeAdmin.
      // The Branch Validation Inbox renders a different Action column per
      // stage, so userSearch is told which stage is asking.
      approvalStage: sessionStorage.getItem('approvalStage') || '',
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if (state == "MADHYAPRADESH" || state == "MP") {
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   console.log("-----------else-----------");
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }


  getIncompleteUsers(input, roleId, offset, limit) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    let filterDate = sessionStorage.getItem('filterDateDashboard')
      ? sessionStorage.getItem('filterDateDashboard')
      : '';
    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_incomplete_jrny',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if (state == "MADHYAPRADESH" || state == "MP") {
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   console.log("-----------else-----------");
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

  getIncompleteUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_incomplete_jrny',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate1 = sessionStorage.getItem('filterDateIncomplete')
      ? sessionStorage.getItem('filterDateIncomplete')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    //if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

   getReviewInoboxUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'review',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
      approvalStage: sessionStorage.getItem('approvalStage') || '',
    };
    let filterDate1 = sessionStorage.getItem('filterDateReviewInbox')
      ? sessionStorage.getItem('filterDateReviewInbox')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    //if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

  updateKycCompliance(body) {
    const { appId } = body;
    return this.api
      .postResUserSearch('/v1/users/updatentbcheck', {
        appId: appId,
        type: 'kyc',
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  LoanExecutedDate(body) {
    const { appId, date } = body;
    return this.api
      .postResUserSearch('/v1/users/updatentbcheck', {
        appId: appId,
        type: 'lde',
        date: date,
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  updateCropLien(body) {
    const { appId } = body;
    return this.api
      .postResUserSearch('/v1/users/updatentbcheck', {
        appId: appId,
        type: 'cropLienCreated',
      })
      .pipe(map((res) => {
        return res;
      }));
  }

  getLoanDisbursedUsers(input, roleId, offset, limit) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    let filterDate = sessionStorage.getItem('filterDateDashboard')
      ? sessionStorage.getItem('filterDateDashboard')
      : '';
    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_disbursed',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if(state =="MADHYAPRADESH" || state == "MP"){
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));

    // } else {
    //   console.log('-----------else-----------');
    //   return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if(resp && resp.result && resp.result.resultData){
    //       return resp;
    //     }

    //   })
    // }
  }

  getEtbUsers(input, roleId, offset, limit) {
    let adminId = sessionStorage.getItem('wl-admin-id');
    let filterDate = sessionStorage.getItem('filterDateDashboard')
      ? sessionStorage.getItem('filterDateDashboard')
      : '';
    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_sanctioned_etb',
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    if (filterDate) {
      let date = new Date(filterDate);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }

    let state = sessionStorage.getItem('stateCode');

    console.log('userState------->', state);

    // if(state =="MADHYAPRADESH" || state == "MP"){
    console.log('----------------------');
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));

    // } else {
    //   console.log('-----------else-----------');
    //   return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if(resp && resp.result && resp.result.resultData){
    //       return resp;
    //     }

    //   })
    // }
  }

  getRoleId() {
    return sessionStorage.getItem('getroleId');
  }

  getEtbUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_sanctioned_etb',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    // let filterDate1 = sessionStorage.getItem("filterDateEtb")
    //   ? sessionStorage.getItem("filterDateEtb")
    //   : "";
    // if (filterDate1) {
    //   let date = new Date(filterDate1);
    //   let dateInMs = date.getTime();
    //   dataObj["filter_date"] = dateInMs;
    // }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    //if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // }
    // else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

  getLoanDisbursedUsersFilterDate(input, roleId, offset, limit, filterDate, endDateInMs, dateType) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let dataObj = {
      adminId: adminId,
      roleId: this.getRoleId(),
      filter: input,
      offset: offset,
      limit: limit,
      data_type: 'loan_disbursed',
      filter_date: filterDate,
      end_date: endDateInMs,
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };
    let filterDate1 = sessionStorage.getItem('filterDateDisbursed')
      ? sessionStorage.getItem('filterDateDisbursed')
      : '';
    if (filterDate1) {
      let date = new Date(filterDate1);
      let dateInMs = date.getTime();
      dataObj['filter_date'] = dateInMs;
    }
    // return this.api.postRes('/users/userSearch', dataObj).map(resp => {
    //   // console.log("userSearch resp in service " + JSON.stringify(resp));
    //   return resp;
    // })

    let state = sessionStorage.getItem('stateCode');
    console.log('userState------->', state);

    // if (state == "MADHYAPRADESH" || state == "MP") {
    return this.api.postResUserSearch('/v1/applicants/userSearch', dataObj).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      if (resp && resp.result && resp.result.resultData) {
        return resp;
      }
    }));
    // } else {
    //   return this.api.postRes("/users/userSearch", dataObj).map((resp) => {
    //     // console.log("userSearch resp in service " + JSON.stringify(resp));
    //     if (resp && resp.result && resp.result.resultData) {
    //       return resp;
    //     }
    //   });
    // }
  }

  getSummaryFilterDate(roleId, filterDate, endDateInMs, dateType) {
    let adminId = sessionStorage.getItem('wl-admin-id');

    let storeDate = {
      from: filterDate,
      to: endDateInMs,
    };
    let dataObj = {
      date: storeDate,
      adminId: adminId,
      roleId: this.getRoleId(),
      date_type: dateType,
      branch_code: sessionStorage.getItem('branch_code'),
      ro_code: sessionStorage.getItem('ro_code'),
      zonal_code: sessionStorage.getItem('zonal_code'),
    };

    return this.api.postResUserSearch('/v1/pdf/getdashboardsummary', dataObj).pipe(map((resp) => {
      if (resp && resp.result) {
        return resp;
      }
    }));
  }

  getCurrentMonth() {
    var todayDate = new Date();
    this.getMonth = todayDate.getMonth() + 1;
    console.log('month', this.getMonth);
    this.getYear = todayDate.getUTCFullYear();
    if (this.getMonth < 10) {
      this.getMonth = '0' + this.getMonth;
      console.log('add 0', this.getMonth);
    }
    return (this.maxDate = this.getYear + '-' + this.getMonth);
  }

  getSummary(payload: any) {
    let desiredPayload = {
      date: payload.date,
      branch_code: payload.branch,
      zonal_code: payload.zone,
      ro_code: payload.region,
      adminId: this.adminId,
      roleId: this.getRoleId(),
    };
    return this.api.postRes('/pdf/getdashboardsummary', desiredPayload);
  }

  getEtb(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'loan_sanctioned_etb',
    };

    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, false);
  }

  getFailures(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'loan_failure_page',
    };

    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, false);
  }

  getIncompleteJourneys(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'loan_incomplete_jrny',
    };

    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, false);
  }

   getReviewInboxJourneys(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'review',
      approvalStage: sessionStorage.getItem('approvalStage') || '',
    };

    // isResult TRUE, then flattened — same reason as loan_Review_Inbox_jrny:
    // passing false hands back res['result'] and drops approvalStage, which
    // lives on the envelope beside it.
    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, true)
      .pipe(map((res) => ({
        ...(res && res.result ? res.result : {}),
        approvalStage: res && res.approvalStage,
      })));
  }

  getDisbursed(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'loan_disbursed',
    };

    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, false);
  }

  getSanctioned(payload: any) {
    let desiredPayload = {
      adminId: this.adminId,
      branch_code: payload.branch,
      ro_code: payload.region,
      zonal_code: payload.zone,
      roleId: this.getRoleId(),
      filter: payload.filter,
      offset: payload.offset,
      limit: 10,
      filter_date: this.parseDateString(payload.date.from).getTime(),
      end_date: this.parseDateString(payload.date.to).getTime(),
      date_type: 'dateRange',
      data_type: 'loan_sanctioned_ntb',
    };

    return this.api.userSearchIsResultTrue(`${this.searchEndpoint}`, desiredPayload, false);
  }

  parseDateString = (dateString: string) => {
    const parts = dateString.split('-');
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    return new Date(year, month, day);
  };
  
  downloadPdfAccWise(appId){
    return this.api.postResMp(`/pdf/kcc-bre-checklist`,{appId})
  }

  createCifId(applicantId){
    return this.api.postWebhook('/v1/account/create-cifid', { applicantId })

  }

  // A consent document is handed out by referenceId, not by URL — the
  // referenceIds come from the application's landConsentDocs. The document
  // itself comes back as { fileName, fileType, fileBase64 } inside result, so
  // the caller turns it into a blob rather than navigating to a URL.
  getConsentDoc(appId: string, referenceId: string){
    return this.api.getResUserSearch('/v1/mcu/getmcdocs', { appId, referenceId });
  }

  // /v1/mcu/makerconsent requires the consent PDF, carried as base64 in the
  // JSON body (consentPdf / fileType). land_data stays a real array.
  //
  // The response is passed straight back, unfiltered. Every failure arrives as
  // HTTP 200 with status:false, so the old `if (resp.result.resultData)` guard
  // would hand the caller `undefined` on a rejected submit and the screen would
  // read that as a success.
  getMakerConsent(data){
    return this.api.postResUserSearch('/v1/mcu/makerconsent', data);
  }


  getCheckerConsent(data){
    return this.api.postResUserSearch('/v1/mcu/checkerconsent', data).pipe(map((resp) => {
      // console.log("userSearch resp in service " + JSON.stringify(resp));
      // Passed through as it arrives — /checkerconsent answers
      // { status, message } with no result.resultData, so filtering on that
      // handed the caller undefined and lost the message it has to show.
      return resp;
    }));
  }
}
